import React from 'react'

// functional component. No lifecycle hooks
export default () => {
	return (
	<nav className="navbar navbar-light bg-info justify-content-center" >
	  <div className="text-white text-center">
      Copyright &copy; {new Date().getFullYear()} AlanB
      </div>
    </nav>
	)
}


// WEBPACK FOOTER //
// ./src/components/layout/footer.jsx